/**
 * An incomplete map of template functions, ordered in an approximation of rank
 */
export const functionIds = {
  // Management
  generalManager: 179,
  hrManager: 181,
  financialManager: 183,
  hseManager: 193,
  infectionControlOfficer: 7956,
  radiationProtectionCoordinator: 6345,
  academicSupervisor: 186,
  equipmentManager: 190,
  ictManager: 195,
  qualityManager: 199,
  // Main professions
  doctor: 3765,
  // Subordinate professions
  treatmentRoom: 171,
  lab: 174,
  reception: 168,
  // Management assistance
  financialAssistant: 176,
  // Employee representatives
  safetyRepresentative: 13962,
  // Supporting functions
  cleaner: 8032,
  // collective
  common: 429,
};
